/** Strip simple markdown markers for display titles. */
export function stripMarkdownForTitle(text) {
  return String(text || '')
    .replace(/\*\*|__|\*|_|`/g, '')
    .replace(/^#+\s*/, '')
    .trim();
}

/** First non-empty line of body, markdown-stripped. */
export function firstLineFromBody(body) {
  const lines = String(body || '').split(/\r?\n/);
  for (const line of lines) {
    const t = line.trim();
    if (t) return stripMarkdownForTitle(t);
  }
  return '';
}

export function resolveNoteTitle(title, body) {
  const explicit = String(title || '').trim();
  if (explicit) return explicit;
  const fromBody = firstLineFromBody(body);
  return fromBody || 'Untitled note';
}

export function noteListLabel(note) {
  if (!note) return 'Untitled note';
  return resolveNoteTitle(note.title, note.body);
}

/**
 * @param {string} text
 * @param {number} start
 * @param {number} end
 * @param {string} before
 * @param {string} after
 */
export function wrapTextRange(text, start, end, before, after) {
  const s = Math.max(0, Math.min(start, text.length));
  const e = Math.max(s, Math.min(end, text.length));
  const selected = text.slice(s, e);
  const next = `${text.slice(0, s)}${before}${selected || ''}${after}${text.slice(e)}`;
  const caret = s + before.length + (selected ? selected.length : 0) + after.length;
  return { text: next, selectionStart: caret, selectionEnd: caret };
}

export function prefixLines(text, start, end, prefix) {
  const s = Math.max(0, Math.min(start, text.length));
  const e = Math.max(s, Math.min(end, text.length));
  const block = text.slice(s, e);
  const lines = block.split(/\r?\n/);
  const indented = lines.map((ln) => (ln.trim() === '' ? ln : `${prefix}${ln}`)).join('\n');
  const next = `${text.slice(0, s)}${indented}${text.slice(e)}`;
  return { text: next, selectionStart: s, selectionEnd: s + indented.length };
}

export const NOTE_SIZE_OPTIONS = [
  { id: 'large', label: 'Large', prefix: '# ' },
  { id: 'medium', label: 'Medium', prefix: '## ' },
  { id: 'small', label: 'Small', prefix: '' },
];
